import { Separator } from "@app/components/core/Separator/Separator"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { AddressSelectionModal } from "@app/modals/AddressSelectionModal/AddressSelectionModal"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetCountries, useGetSalutations } from "@app/store/service/connectorService"
import { mapAmazonToAddresses } from "@app/utils/amazon"
import { ADRESS_TYPES } from "@app/utils/constants"
import { useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { Link } from "../LinkList/LinkList"

export function Addresses({ amazonPayData }) {
	let deliveryAddress = useSelector("core.deliveryAddress")
	let invoiceAddress = useSelector("core.invoiceAddress")

	const relation = useSelector(state => state.core.relation)
	const { data: countries } = useGetCountries()
	const { data: salutations } = useGetSalutations()
	const {
		data: { invoiceAddress: invoiceAddressTitle, deliveryAddress: deliveryAddressTitle, address },
	} = useGetStrings(undefined, { defaultData: {} })
	const modal = useModal()
	const { pop } = useCustomNavigation()

	if (amazonPayData) {
		const mapped = mapAmazonToAddresses(amazonPayData)
		deliveryAddress = mapped.deliveryAddress
		invoiceAddress = mapped.invoiceAddress
	}

	if (invoiceAddress) {
		let salutation1 = undefined
		let salutation2 = undefined
		if (invoiceAddress && invoiceAddress.genderId) {
			let s = (salutations || []).find(e => e.genderId == invoiceAddress.genderId)
			if (s) {
				salutation1 = s.salutation
			}
		} else if (relation) {
			let s = (salutations || []).find(e => e.genderId == relation.genderId)
			if (s) {
				salutation1 = s.salutation
			}
		}

		if (deliveryAddress && deliveryAddress.genderId) {
			let s = (salutations || []).find(e => e.genderId == deliveryAddress.genderId)
			if (s) {
				salutation2 = s.salutation
			}
		}

		if (!deliveryAddress) {
			// deliveryAddress = invoiceAddress;
		}
		let invoiceCountry = !countries
			? undefined
			: countries.find(e => e.countryId == invoiceAddress.countryId || e.countryCode.toUpperCase() === invoiceAddress.countryCode)
		let deliveryCountry =
			!countries || !deliveryAddress
				? undefined
				: countries.find(e => e.countryId == deliveryAddress.countryId || e.countryCode.toUpperCase() === deliveryAddress.countryCode)

		return (
			<div className="mb-4">
				<div id="order-overview-addresses-title" className="f4 semibold">
					{address}
				</div>
				<Separator />

				<div
					className="color-bg-secondary-100 p-3 flex flex-column flex-justify-between flex-md-row"
					role="group"
					aria-labelledby="order-overview-addresses-title"
				>
					<div className="flex-1 f5 mr-4">
						<div className="semibold mb-2 f4 flex">
							{invoiceAddressTitle}
							<div className="ml-2 clickable">
								{!amazonPayData && (
									<div className="f6 mt-1">
										<Link
											onClick={e => {
												e.preventDefault()
												if (invoiceAddress.addressToken) {
													modal.showModal(AddressSelectionModal, { address: invoiceAddress })
												} else {
													pop(-1)
												}
											}}
											href=""
										>
											Ändern
										</Link>
									</div>
								)}
							</div>
						</div>
						{invoiceAddress.companyName && <div>{invoiceAddress.companyName}</div>}
						<div>
							{salutation1} {invoiceAddress.firstName} {invoiceAddress.lastName}
						</div>
						<div>{invoiceAddress.addressAddition}</div>
						<div>{invoiceAddress.company}</div>
						{invoiceAddress.address && (
							<div>
								{invoiceAddress.address} {invoiceAddress.houseNo}
							</div>
						)}

						<div>
							{invoiceAddress.zipCode} {invoiceAddress.city}
						</div>
						<div>{invoiceAddress.email}</div>
						{countries && <div>{invoiceCountry ? invoiceCountry.country : ""}</div>}
					</div>
					<div className="flex-1 f5 mt-3 mt-md-0">
						<div className="semibold mb-2 f4 flex">
							{deliveryAddressTitle}
							<div className="ml-2 clickable">
								{!amazonPayData && (
									<div className="f6 mt-1">
										<Link
											onClick={e => {
												e.preventDefault()
												if (relation && !relation.guest) {
													modal.showModal(AddressSelectionModal, {
														address: deliveryAddress ? deliveryAddress : { addressTypeId: ADRESS_TYPES.DELIVERY },
													})
												} else {
													pop(-1)
												}
											}}
											href=""
										>
											Ändern
										</Link>
									</div>
								)}
							</div>
						</div>
						{!deliveryAddress && <div>Keine abweichende Lieferadresse</div>}
						{deliveryAddress && (
							<>
								<div>{deliveryAddress.companyName}</div>
								<div>
									{salutation2} {deliveryAddress.firstName} {deliveryAddress.lastName}
								</div>
								<div>{deliveryAddress.addressAddition}</div>
								<div>
									{deliveryAddress.address} {deliveryAddress.houseNo}
								</div>
								<div>
									{deliveryAddress.zipCode} {deliveryAddress.city}
								</div>
								<div>{deliveryAddress.email}</div>
								{countries && <div>{deliveryCountry?.country}</div>}
							</>
						)}
					</div>
				</div>
			</div>
		)
	} else {
		return null
	}
}
